import { Box, Button, Stack, TextField } from "@mui/material";
import { FC, FormEvent, useState } from "react";
import { RejectUserProps } from "./reject-user.types";
import { useRejectUser } from "../../queries";
import { useUIStore } from "@/stores";

const RejectUser: FC<RejectUserProps> = ({ userId }) => {
  const { closeModal } = useUIStore();
  const { rejectUser, isRejectUserLoading } = useRejectUser();

  const [vettingNote, setVettingNote] = useState<string>("");

  const onSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    rejectUser({
      userId,
      vettingNote: vettingNote.length ? vettingNote : undefined,
    });
  };

  return (
    <Box component="form" onSubmit={onSubmit}>
      <TextField
        multiline
        label="Reject Reason"
        slotProps={{ htmlInput: { maxLength: 500 } }}
        minRows={10}
        value={vettingNote}
        onChange={({ target: { value } }) => setVettingNote(value)}
      />

      <Stack direction={"row"} spacing={2} mt={2}>
        <Button
          fullWidth
          variant="contained"
          color="primary"
          disabled={isRejectUserLoading}
          onClick={closeModal}
        >
          Cancel
        </Button>
        <Button
          fullWidth
          variant="contained"
          color="error"
          type="submit"
          loading={isRejectUserLoading}
          disabled={isRejectUserLoading}
        >
          Reject
        </Button>
      </Stack>
    </Box>
  );
};

export { RejectUser };
